export interface AccentsTheme {
  floatingShadow: any;
}

export default {
  floatingShadow:
    '0px 2px 4px -1px rgba(0, 0, 0, 0.10), 0px 1px 10px 0px rgba(0, 0, 0, 0.06), 0px 4px 5px 0px rgba(0, 0, 0, 0.07)',
} as AccentsTheme;
